'use client'

import { useNavigate } from 'react-router-dom';
import style from './error.module.css';
import { Button, Image, Link } from '@nextui-org/react';
export default function ErrorUnauthenticatedNotFound() {
  const navigate = useNavigate()
    return (
      <main className={style.main}>
        <Image
          src={'/img/illustration-404.png'}
          width={600}
          height={320}
          alt='Illustration of page error'
        />
        <div className={style.content}>
          <span className={style.title}>
              Oops! Halaman Tidak Ditemukan.
          </span>
          <span className={style.subtitle}>
            Sepertinya halaman yang kamu cari tidak tersedia atau telah dipindahkan.
          </span>
        </div>
        <Button onPress={() => navigate(-1, { replace: true })} radius='none' color='primary'>
                Kembali
            </Button>
    </main>
    )
  }